import React from 'react';
import { ProgressBar } from 'react-bootstrap';

function ProgressBarPercent(props) {
    const {progressPercent} = props;
    return (
        <ProgressBar now={progressPercent}/>
    );
  }
  export default ProgressBarPercent;